import React, { useState } from 'react';
import { css } from 'styled-components';
import _some from 'lodash/some';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';
import { STRINGS } from 'config';
import media from 'styles/media';
import { Address } from 'components/consultation/answers/address';
import { containsNonPostcodeChars } from 'components/consultation/answers/address/postcode';
import CompoundAnswer from 'styles/blocks/compound';
import { NextButton } from '../nextButton';

const { POSTCODE: POSTCODE_TAG, ADDRESS: ADDRESS_TAG, CITY: CITY_TAG } = STRINGS.TAGS.QUESTION.DEMOGRAPHICS;

export const calculateAnswerStyles = tags => {
  if (tags.includes(ADDRESS_TAG)) {
    return `
        width: 55%;
        margin-left: 0;
        flex: none;
      `;
  }
  if (tags.includes(POSTCODE_TAG)) {
    return 'display: none;';
  }
  return '';
};

export const addressBodyContainerStyles = css`
  gap: 50px;
  flex-direction: row;
  align-items: flex-end;
  ${media.smallAndBelow`
    align-items: stretch;
    flex-direction: column;
    gap: 0px;
  `}
`;

const keyQuestionIdsByTag = answers => _reduce(answers, (result, answer, questionId) => ({
  ...result,
  ..._reduce(answer.questionTags, (tagsResult, tag) => ({ ...tagsResult, [tag]: questionId }), {}),
}), {});

const getAnswerIdByTag = (tag, answers) => {
  return _find(answers, answer => answer.questionTags.includes(tag)).answerId;
};

export function CompoundAddress(props) {
  const { question, onClickNextQuestion, compoundAnswers, handleUpdateCompoundAnswer, isReadOnly, children } = props;
  const { ADDRESS, CITY, POSTCODE } = keyQuestionIdsByTag(compoundAnswers);
  const [POSTCODE_COMPOUND_QUESTION_ID] = useState(() => POSTCODE);
  const [ADDRESS_COMPOUND_QUESTION_ID] = useState(() => ADDRESS);
  const [CITY_COMPOUND_QUESTION_ID] = useState(() => CITY);

  const [POSTCODE_COMPOUND_ANSWER_ID] = useState(() => getAnswerIdByTag(POSTCODE_TAG, compoundAnswers));
  const [ADDRESS_COMPOUND_ANSWER_ID] = useState(() => getAnswerIdByTag(ADDRESS_TAG, compoundAnswers));
  const [CITY_COMPOUND_ANSWER_ID] = useState(() => getAnswerIdByTag(CITY_TAG, compoundAnswers));

  function handleUpdateSelectAddress(selectedAddress) {
    const addressValues = {
      [ADDRESS_COMPOUND_QUESTION_ID]: {
        answerId: ADDRESS_COMPOUND_ANSWER_ID,
        questionTags: compoundAnswers[ADDRESS_COMPOUND_QUESTION_ID].questionTags,
        value: selectedAddress.displayName,
      },
      [CITY_COMPOUND_QUESTION_ID]: {
        answerId: CITY_COMPOUND_ANSWER_ID,
        questionTags: compoundAnswers[CITY_COMPOUND_QUESTION_ID].questionTags,
        value: selectedAddress.city,
      },
    };
    handleUpdateCompoundAnswer(addressValues);
  }

  const isNextButtonDisabled = _some(compoundAnswers, answer => _isEmpty(answer.value)) || containsNonPostcodeChars(compoundAnswers[POSTCODE_COMPOUND_QUESTION_ID]?.value);
  const postCodeText = _find(question.questions, subQuestion => subQuestion.tags.includes(POSTCODE_TAG))?.text;
  return (
    <CompoundAnswer>
      <Address
        showQuestionText
        onSelectAddress={handleUpdateSelectAddress}
        postcode={compoundAnswers[POSTCODE_COMPOUND_QUESTION_ID]?.value}
        questionText={postCodeText}
        onUpdatePostcode={postcode => (
          handleUpdateCompoundAnswer({
            [POSTCODE_COMPOUND_QUESTION_ID]: {
              answerId: POSTCODE_COMPOUND_ANSWER_ID,
              value: postcode,
              questionTags: compoundAnswers[POSTCODE_COMPOUND_QUESTION_ID].questionTags,
            },
          }))}
        onUpdateCity={city => (
          handleUpdateCompoundAnswer({
            [CITY_COMPOUND_QUESTION_ID]: {
              answerId: CITY_COMPOUND_ANSWER_ID,
              value: city,
              questionTags: compoundAnswers[CITY_COMPOUND_QUESTION_ID].questionTags,
            },
          }))}
        isReadOnly={isReadOnly}
        postcodeAnswerId={POSTCODE_COMPOUND_ANSWER_ID}
      />
      { children }
      <NextButton dataAutomation={`nextButton-${question.questionId}`} onClick={onClickNextQuestion} isDisabled={isNextButtonDisabled} />
    </CompoundAnswer>
  );
}
